(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["button"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll(".custom-buttons a").forEach(btn => {
      btn.addEventListener("mouseenter", () => {
        btn.style.opacity = "0.8";
      });
      btn.addEventListener("mouseleave", () => {
        btn.style.opacity = "1";
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
